import './dtos';
import { StudyApplicationBase } from './study';
import { DataProjectBase } from './dataProject';
import { IPost, IReturn } from './dtos';
import { IActiveSession } from '@servicestack/client';
export class UserInfo {
    public userId?: any;
    public userName?: any;
    public rowId: any;
    public constructor(init?: Partial<UserInfo>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new UserInfoResponse();
    }
    public getTypeName() {
        return 'UserInfoRequest';
    }
}

export class UserInfoResponse {
    public userInfo?: User;
    public study?: StudyApplicationBase;
    public data?: DataProjectBase;

    public constructor(init?: Partial<UserInfoResponse>) {
        (Object as any).assign(this, init);
    }
}

export class User {
    applicationId: number;
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    institution: string;
    lastLoginDate: string;
    verificationId?: string;
    verificationStatus?: string;
    verificationDate: string;
}

export class ForgotPwd {
    public userName?: any;
    public constructor(init?: Partial<ForgotPwd>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new ForgotPwdResponse();
    }
    public getTypeName() {
        return 'ForgotPassword';
    }
}

export class ForgotPwdResponse {
    public result?: any;
    public constructor(init?: Partial<ForgotPwdResponse>) {
        (Object as any).assign(this, init);
    }
}

export class ResetPassword implements IReturn<ResetPasswordResponse>, IPost {
    public resetPasswordToken?: any;
    public userName?: any;
    public newPassword?: any;
    public confirmPassword?: any;
    public constructor(init?: Partial<ResetPassword>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new ResetPasswordResponse();
    }
    public getTypeName() {
        return 'ResetPassword';
    }
}

export class ResetPasswordResponse {
    public validToken?: any;
    public result?: any;
    public resetPasswordToken?: any;
    public userName?: any;
    public newPassword?: any;
    public confirmPassword?: any;
    public constructor(init?: Partial<ResetPasswordResponse>) {
        (Object as any).assign(this, init);
    }
}

export class ValidateAccessRequest
    implements IReturn<ValidateAccessResponse>, IPost {
    public sessionId?: any;
    public constructor(init?: Partial<ValidateAccessRequest>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new ValidateAccessResponse();
    }
    public getTypeName() {
        return 'ValidateSessionRequest';
    }
}

export class ValidateAccessResponse {
    public result?: any;
    public username?: any;
    public token?: any;
    public constructor(init?: Partial<ValidateAccessResponse>) {
        (Object as any).assign(this, init);
    }
}

export class ActiveSession implements IActiveSession {
    public sessionId: string;
    public constructor(init?: Partial<ActiveSession>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new ActiveSessionResponse();
    }
    public getTypeName() {
        return 'ActiveSessionRequest';
    }
}
export class ActiveSessionResponse {
    public result: any;
    public constructor(init?: Partial<ActiveSessionResponse>) {
        (Object as any).assign(this, init);
    }
}
